import { alpha, keyframes } from '@mui/material/styles';

export const pulse = (color: string) => keyframes`
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 ${alpha(color, 0.7)};
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 5px  ${alpha(color, 0)};
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0  ${alpha(color, 0)};
    }
  `;
